var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"incomes"},[_c('circles-sums-visualizer',{attrs:{"sumsByExpense":_vm.sums,"transactions":_vm.mergedTransactions,"expense-type":_vm.expenseType,"circle-size-thresholds":_vm.circleSizeThresholds,"month":_vm.month}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }